// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// API
import { getProgressionReportInfo } from "../../api";

export const useProgressionReportInfo = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();

  return useMutation({
    mutationFn: async (params: { patientId: string; analysisId: string }) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        const controller = new AbortController();
        return getProgressionReportInfo(
          token,
          clinicId,
          params.patientId,
          params.analysisId,
          controller.signal
        );
      } catch (error) {
        throw error;
      }
    },
    // Invalidate query cache
    onSuccess: (_) => {
      queryClient.invalidateQueries({
        queryKey: ["progression-report-info"],
      });
    },
  });
};
